import { formatPrice } from '@rcg/pricing-format';

const getFormatPrice = (locale, value, showDecimal = false) =>
  formatPrice(value, locale.currency, showDecimal, true, false);

export default getFormatPrice;
